const top100Films = [
    { label: 'Lodhi Colony', year: 1994 },
    { label: 'Greater Kailash', year: 1994 },
  ];

  export default top100Films;